var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("b", [_vm._v("Projects")]),
          _c("v-spacer"),
          _c(
            "router-link",
            {
              staticClass: "mx-2",
              attrs: {
                to: `/pages/research/client/${_vm.$route.params.clientId}/projects`,
              },
            },
            [
              _c(
                "v-btn",
                { attrs: { small: "", color: "primary", outlined: "" } },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-format-list-bulleted"),
                  ]),
                  _vm._v(" View All Projects "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a",
            {
              staticClass: "mx-4",
              attrs: {
                href: `#/pages/research/client/${_vm.$route.params.clientId}/new-project`,
              },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "float-sm-right mt-2 mx-2",
                  attrs: { small: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("createReq")
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("mdi-plus-box-outline"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _vm._l(_vm.projects, function (project) {
        return _c(
          "v-list-item",
          { staticClass: "card-shadow border-radius-xl py-2 mb-2" },
          [
            _c(
              "v-list-item-content",
              [
                _c("v-list-item-title", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-h6 font-weight-bold text-decoration-none",
                      attrs: {
                        href: `#/pages/projects/${project.id}/clusters`,
                      },
                    },
                    [_vm._v(_vm._s(project.name))]
                  ),
                ]),
                _c("v-list-item-subtitle", { staticClass: "mb-2" }, [
                  _vm._v(" " + _vm._s(project.description || "N/A") + " "),
                  _c("br"),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "v-chip",
                      {
                        class: {
                          flat: !_vm.isFailStatus(project),
                          red: _vm.isFailStatus(project),
                          green: _vm.isSuccessStatus(project),
                        },
                        attrs: { small: "" },
                      },
                      [_vm._v(" " + _vm._s(project.status || "N/A") + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }